import React, {useEffect, useState} from "react";
import $ from 'jquery';
import {Link, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import {useForm} from "react-hook-form";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import Filters from "./Filters";
import {downloadBlob} from "../../Components/Helpers/Utils";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);
  const user = useSelector(state => state.user);
  const isAdmin = user?.isAdminType;

  const [errors, setErrors] = useState({});

  const [filters, setFilters] = useState({
    forceSearch: false,
  });

  const {register, handleSubmit, control, reset, getValues} = useForm({
    defaultValues: {
      category_id: null,
      max_price: null,
      min_price: null,
      shop_id: null,
    }
  })

  const [data, setData] = useState({});

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_URL;

    let table = $('#cartItems').DataTable({
      "destroy" : true,
      "ajax": {
        url: `${baseUrl}cart-items`,
        data: {...filters},
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.post('/logout')
              .then(res => {
                localStorage.removeItem('persist:root');
                navigate('/login');
              });
          }
        }
      },
      "columns": [
        {data: 'name', name: 'name'},
        {data: 'sku', name: 'sku'},
        {data: 'price', name: 'price'},
        {data: 'shop.name', name: 'shop.name', orderable: false,},
        {data: 'total_quantity', name: 'total_quantity', orderable: false, searchable: false,},
        {data: 'quantity_in_carts', name: 'quantity_in_carts', orderable: false, searchable: false,},
        {
          data: 'view-customers',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            return `<button 
                class="btn btn-primary me-2 mb-2 bg-black-transperent send-coupon"
                row-productId="${row.id}">
                  View customers
                </button>`;
          },
        }
      ],
      columnDefs: [
        {
          targets: [0],
          orderData: [0],
        },
      ],
    });

    table.on('click', 'button.send-coupon', function () {
      const productId = $(this).attr("row-productId");
      navigate(`/coupon-promotions/${productId}/carts`);
    });

    $("<span class='table-filter-icon' title='Filter'><i class='fa fa-filter fs-4 br-1000'></i>Filter</span>")
      .insertAfter(".dataTables_length label");

    $(".table-filter-icon").click(function () {
      $(".toggle-filter").slideToggle(200)

      let condition = $(".table-filter-icon i").hasClass("fa-filter");

      $(".table-filter-icon")
        .html(condition ? "<i class='far fa-times-circle fs-4 br-1000'></i>Close"
          : "<i class='fa fa-filter fs-4 br-1000'></i>Filter");
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");
  }, [filters.forceSearch]);

  useEffect(() => {
    axios.get('/products/filters').then(res => {
      setData(res.data.data);
    });
  }, []);

  const handleFiltersSubmit = values => {
    setFilters({...values, forceSearch: !filters.forceSearch});
  }

  const resetFilter = () => {
    reset();
    handleFiltersSubmit();
  }

  const exportCartItems = () => {
    axios.get('exports/cart-items', {
      params: {...filters},
      responseType: 'blob',
    }).then(res => {
      downloadBlob(res.data, 'cart-items.xlsx');
    });
  }

  return (
    <div>
      <div className="mb-5">
        {isAdmin &&
          <div className="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
            <button type="button"
                    className="btn btn-primary"
                    data-bs-toggle="tooltip"
                    title="Export"
                    onClick={exportCartItems}
            >
              <i className="fa fa-download"></i>
              Export
            </button>
          </div>
        }
        <div className="toggle-filter display-none">
          <form onSubmit={handleSubmit(handleFiltersSubmit)} className="row">
            <Filters {...{register, errors, control, data}} />
            <div>
              <SubmitButton
                title="Filter"
                beforeTitle={<><i className="fas fa-sync-alt fs-5 mr-2"></i></>}
              />
              <button
                type="button"
                className="btn btn-lg btn-primary clear-filter mb-5 ml-2 px-5"
                title="Clear Filter"
                onClick={resetFilter}
              >
                  <span className="indicator-label clear-filter-icon">
                    <i className="fa fa-times-circle fs-3 display-contents"></i>
                  </span>
                <span className="clear-filter-text">Clear</span>
              </button>
            </div>
          </form>

        </div>
      </div>
      <table id="cartItems" className="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
        <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
          <th>Name</th>
          <th>SKU</th>
          <th>Price</th>
          <th>Shop</th>
          <th>Quantity</th>
          <th>Quantity In Carts</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody className="text-gray-600 fw-bold">
        </tbody>
      </table>
    </div>
  );
}